import { Modal } from "react-bootstrap";
import Styles from "./Confirmation.module.css";
import Loader from "../SharedComponents/Loader/Loader";
import cancelIcon from "../Assets/cross.png";

export const DeleteConfirmation = (props) => {
  console.log(props, "props");

  return (
    <>
      <div className={Styles.parentContainer + " container-fluid"}>
        <div className="container">
          <Modal
            size="xs"
            show={props?.isOpen}
            onHide={props?.onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className={Styles.cancelImgParentContainer}>
                <div>
                  <p className="fontBold">Confirmation</p>
                </div>
                <div className={Styles.cancelImgContainer}>
                  <img
                    onClick={props.onHide}
                    src={cancelIcon}
                    alt="cancel"
                    className={Styles.cancelImg}
                  />
                </div>
              </div>
              <div className={Styles.container}>
                <p>Are you sure you want to delete this Product?</p>
              </div>

              <div className={Styles.btnContainer}>
                <button onClick={props?.onHide} className={Styles.Resetbtn}>
                  Cancel
                </button>
                <button onClick={props?.onSucess} className={Styles.btn}>
                  Delete
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};
